import React, { useState } from 'react'

import './styles.css'
import ContactForm from './components/ContactForm'
import Disclaimer from './components/Disclaimer'
import { EResult } from './components/ContactForm/components/Result'
import VariantWrapper from '../VariantWrapper'
import { variants } from '../../constants/variant'
import Modal from '../Modal'

function Sidebar({ className = '', onToggle = () => { }, onTransitionEnd = () => { }, onFormResult }) {
  const [openModal, setOpenModal] = useState(null)

  const handleOpenModal = (type) => (e) => {
    e.preventDefault()
    setOpenModal(type)
  }

  const handleCloseModal = () => {
    setOpenModal(null)
  }

  return (
    <div
      onTransitionEnd={onTransitionEnd}
      id="sidebar"
      className={`w-[var(--sidebar-width)] max-h-[screen] overflow-y-auto relative z-[400] shadow-xl flex-shrink-0 bg-white pb-[16px] px-[24px] border-l-[1px] border-solid border-[#C7CCD9] flex flex-col justify-between ${className}`}
    >
      <div>
        <ContactForm
          onResult={onFormResult}
          onClose={(result) => {
            if (result === EResult.SUCCESS) {
              onToggle(false)
            }
          }}
        />
      </div>
      <VariantWrapper show={[variants.av]}>
        <div className='text-[12px] leading-[18px] text-[#3D4256] text-center' id='avalon-sidebar-footer'>
          <a
            href="#"
            onClick={handleOpenModal('terms')}
            className="hover:underline transition-colors cursor-pointer"
          >
            Terms of Use
          </a>
          {' · '}
          <a
            href="#"
            onClick={handleOpenModal('privacy')}
            className="hover:underline transition-colors cursor-pointer"
          >
            Privacy Policy
          </a>
        </div>
      </VariantWrapper>

      {openModal === 'privacy' && (
        <Modal onClose={handleCloseModal}>
          <div className="max-w-[600px] max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-[#3D4256]">Privacy Policy</h2>
              <button
                onClick={handleCloseModal}
                className="text-[#3D4256] hover:text-[#1a1d2e] text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <div className="text-[#3D4256] space-y-4 text-sm leading-relaxed">
              <p><strong>Last Updated:</strong> December 10, 2025</p>
              
              <p>
                This Privacy Policy describes how we collect, use, and share your personal information when you use our services.
              </p>

              <h3 className="font-bold text-base mt-4">Information We Collect</h3>
              <p>
                We collect information that you provide directly to us, including your name, email address, phone number, 
                and any other information you choose to provide when you fill out our contact form or interact with our services.
              </p>

              <h3 className="font-bold text-base mt-4">How We Use Your Information</h3>
              <p>
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6">
                <li>Respond to your inquiries and provide customer support</li>
                <li>Send you information about our properties and services</li>
                <li>Improve and personalize your experience</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h3 className="font-bold text-base mt-4">Information Sharing</h3>
              <p>
                We may share your information with service providers who assist us in operating our business, 
                as well as when required by law or to protect our rights.
              </p>

              <h3 className="font-bold text-base mt-4">Your Rights</h3>
              <p>
                You have the right to access, correct, or delete your personal information. 
                Please contact us if you wish to exercise these rights.
              </p>

              <h3 className="font-bold text-base mt-4">Contact Us</h3>
              <p>
                If you have any questions about this Privacy Policy, please contact us through the information provided on our website.
              </p>
            </div>
          </div>
        </Modal>
      )}

      {openModal === 'terms' && (
        <Modal onClose={handleCloseModal}>
          <div className="max-w-[600px] max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-[#3D4256]">Terms of Use</h2>
              <button
                onClick={handleCloseModal}
                className="text-[#3D4256] hover:text-[#1a1d2e] text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <div className="text-[#3D4256] space-y-4 text-sm leading-relaxed">
              <p><strong>Last Updated:</strong> December 10, 2025</p>
              
              <p>
                Welcome to our service. By accessing or using our website and services, you agree to be bound by these Terms of Use.
              </p>

              <h3 className="font-bold text-base mt-4">Acceptance of Terms</h3>
              <p>
                By using this service, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.
              </p>

              <h3 className="font-bold text-base mt-4">Use of Service</h3>
              <p>
                You agree to use our service only for lawful purposes and in accordance with these Terms. 
                You may not use our service in any way that could damage, disable, or impair the service.
              </p>

              <h3 className="font-bold text-base mt-4">Intellectual Property</h3>
              <p>
                All content, features, and functionality of our service are owned by us or our licensors and are protected by copyright, 
                trademark, and other intellectual property laws.
              </p>

              <h3 className="font-bold text-base mt-4">Disclaimer</h3>
              <p>
                Our service is provided "as is" without warranties of any kind, either express or implied. 
                We do not warrant that the service will be uninterrupted or error-free.
              </p>

              <h3 className="font-bold text-base mt-4">Changes to Terms</h3>
              <p>
                We reserve the right to modify these Terms at any time. Your continued use of the service after changes 
                constitutes acceptance of the modified Terms.
              </p>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

export default Sidebar
